import React from 'react';
import PropTypes from 'prop-types';
import { getAgentInfo } from '../../shared/util';

class ShInquireForm extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    const { entity } = this.props;
    this.ref.current.agent = this.props.agentEmail;
    this.ref.current.showcourtesy = !this.props.entity.region.showBottomCourtesyInfo;
    this.ref.current.listing = this.props.listing;
    if (this.props.listing.isIdx) {
      this.ref.current.agentinfo = getAgentInfo(entity);
    }
  }

  render() {
    return (
      <sh-inquire-form ref={this.ref}></sh-inquire-form>
    );
  }
}

ShInquireForm.propTypes = {
  listing: PropTypes.object.isRequired,
  entity: PropTypes.object.isRequired,
  agentEmail: PropTypes.string.isRequired,
};

export default ShInquireForm;



// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-inquire-form.js